import React, { Component } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import { UsersService } from '../../services/user';
import './fale-conosco.css';

import {
  HeaderShelf,
  SidebarRoundedIcons,
  Footer
} from '../../components';

export default class ViewFaleConosco extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      isUserLoggedIn: false,
      form: {
        name: '',
        email: '',
        telefone: '',
        assunto: '',
        message: ''
      }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const user = UsersService.getUser();
    this.setState({ isUserLoggedIn: user !== null });
  }

  formatPhone(value) {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 10) {
      return cleaned.replace(/(\d{2})(\d{4})(\d{0,4})/, (match, p1, p2, p3) => {
        if (p3) return `(${p1}) ${p2}-${p3}`;
        if (p2) return `(${p1}) ${p2}`;
        if (p1) return `(${p1}`;
        return cleaned;
      });
    } else {
      return cleaned.replace(/(\d{2})(\d{5})(\d{0,4})/, (match, p1, p2, p3) => {
        if (p3) return `(${p1}) ${p2}-${p3}`;
        if (p2) return `(${p1}) ${p2}`;
        if (p1) return `(${p1}`;
        return cleaned;
      });
    }
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    let formattedValue = value;
    
    if (name === 'telefone') {
      formattedValue = this.formatPhone(value);
    }
    
    this.setState({
      form: {
        ...this.state.form,
        [name]: formattedValue
      }
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { form } = this.state;
    
    // Validação básica
    if (!form.name || !form.email || !form.assunto || !form.message) {
      alert('Por favor, preencha os campos obrigatórios.');
      return;
    }

    this.setState({ loading: true });

    try {
      const data = {
        support: {

          user: {
            
            name: form.name,
            email: form.email,
            phone: form.telefone,
          },
          title: form.assunto,
          message: form.message
        }
      }
      
      // const sendData = {
      //   name: form.name,
      //   email: form.email,
      //   telefone: form.telefone,
      //   assunto: form.assunto,
      //   message: form.message
      // };

      const url = `auth/v1.1/directory/request/customers`;
      await Sdk.Api.dynamic.bridge(url, data, "POST");

      alert('Mensagem enviada com sucesso!');
      
      // Limpar formulário
      this.setState({
        form: {
          name: '',
          email: '',
          telefone: '',
          assunto: '',
          message: ''
        }
      });
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
      alert('Ocorreu um erro ao tentar enviar os dados. Tente novamente mais tarde.');
    } finally {
      this.setState({ loading: false });
    }
  }

  onBack() {
    window.location = window.location.origin + window.location.pathname + "#/";
  }

  redirectToLogin() {
    window.location = window.location.origin + window.location.pathname + "#/login";
  }

  render() {
    const { loading, form, isUserLoggedIn } = this.state;
    
    if (loading) {
      return (
        <div className="rdp-react-template-view-fale-conosco">
          <div className="rdp-react-template-view-fale-conosco-loading">
            <div className="rdp-react-template-view-fale-conosco-loader"></div>
          </div>
        </div>
      );
    }

    const isButtonDisabled = !form.name || !form.email || !form.assunto || !form.message || loading;

    return (
      <div className="rdp-react-template-view-fale-conosco">
        <div className="rdp-react-template-view-fale-conosco-header">
          <HeaderShelf
            onSignOut={() => { /* implementar logout */ }}
            renderSearch={false}
            isUserLoggedIn={isUserLoggedIn}
          />
        </div>

        {isUserLoggedIn && (
          <div className="rdp-react-template-view-fale-conosco-sidebar">
            <SidebarRoundedIcons />
          </div>
        )}

        <div className="rdp-react-template-view-fale-conosco-main">
          <div className="rdp-react-template-view-fale-conosco-container">
            <div className="rdp-react-template-view-fale-conosco-header-section">
              <h1 className="rdp-react-template-view-fale-conosco-title">Fale conosco</h1>
            </div>

            <form className="rdp-react-template-view-fale-conosco-form" onSubmit={this.handleSubmit}>
              <div className="rdp-react-template-view-fale-conosco-field">
                <label className="rdp-react-template-view-fale-conosco-label">
                  Nome *
                </label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={this.handleInputChange}
                  placeholder="Digite seu nome"
                  className="rdp-react-template-view-fale-conosco-input"
                  required
                />
              </div>

              <div className="rdp-react-template-view-fale-conosco-field">
                <label className="rdp-react-template-view-fale-conosco-label">
                  E-mail *
                </label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={this.handleInputChange}
                  placeholder="Digite seu e-mail"
                  className="rdp-react-template-view-fale-conosco-input"
                  required
                />
              </div>

              <div className="rdp-react-template-view-fale-conosco-field">
                <label className="rdp-react-template-view-fale-conosco-label">
                  Telefone
                </label>
                <input
                  type="tel"
                  name="telefone"
                  value={form.telefone}
                  onChange={this.handleInputChange}
                  placeholder="(XX) XXXXX-XXXX"
                  className="rdp-react-template-view-fale-conosco-input"
                  maxLength="15"
                />
              </div>

              <div className="rdp-react-template-view-fale-conosco-field">
                <label className="rdp-react-template-view-fale-conosco-label">
                  Assunto *
                </label>
                <input
                  type="text"
                  name="assunto"
                  value={form.assunto}
                  onChange={this.handleInputChange}
                  placeholder="Sobre o que gostaria de falar?"
                  className="rdp-react-template-view-fale-conosco-input"
                  required
                />
              </div>

              <div className="rdp-react-template-view-fale-conosco-field">
                <label className="rdp-react-template-view-fale-conosco-label">
                  Mensagem *
                </label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={this.handleInputChange}
                  placeholder="Digite sua mensagem"
                  className="rdp-react-template-view-fale-conosco-textarea"
                  rows="5"
                  required
                />
              </div>

              <div className="rdp-react-template-view-fale-conosco-submit">
                <button
                  type="submit"
                  className="rdp-react-template-view-fale-conosco-btn"
                  disabled={isButtonDisabled}
                >
                  {loading ? 'Enviando...' : 'Enviar'}
                </button>
              </div>
            </form>
          </div>
          <Footer/>
        </div>
      </div>
    );
  }
}